const __WEBPACK_NAMESPACE_OBJECT__ = require("swagger-client/es/resolver/strategies/openapi-3-2-apidom");